import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import typeSizes from '../../../Typography/shared/typeSizes/typeSizes';
import colors from '../../../Typography/shared/colours/colours';
import { setMultipleRefs } from '../../../_shared/helpers';
import * as styles from './style.module.css';
const RangeWithoutRef = ({ innerRef, value, min, max, step = 1, disabled = false, className, ...commonProps }) => {
    /* VALIDATION: MIN and MAX should be multiple of STEP */
    if (min % step !== 0 || max % step !== 0) {
        console.error('min and max props should be multiple of step prop');
    }
    /* REF: RANGE */
    const rangeRef = useRef(null);
    /* STYLES : component classes */
    const rangeClasses = clsx(className, styles.range, typeSizes.body, colors.base);
    /* Update background progress style */
    useEffect(() => {
        if (!disabled && rangeRef.current && value !== undefined) {
            const progress = ((value - min) / (max - min)) * 100;
            rangeRef.current.style.setProperty('--track-progress', progress ? `${progress}%` : '0%');
        }
    }, [disabled, max, min, rangeRef, value]);
    return Depot.createElement('input', {
        type: 'range',
        innerRef: setMultipleRefs([innerRef, rangeRef]),
        className: rangeClasses,
        value,
        min,
        max,
        step,
        disabled,
        ...commonProps,
    });
};
const Range = Depot.withRef(RangeWithoutRef);
Range.displayName = 'Range';
export default Range;
//# sourceMappingURL=index.js.map